export const API = {
  teams: {
    path: '/teams',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  team: {
    path: '/teams/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/teams',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  update: {
    path: '/teams/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  delete: {
    path: '/teams/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  select: {
    path: '/teams?pagination[page]=1&pagination[pageSize]=1000&sort[name]=asc',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
    transform: (data) =>
      data.map((item) => ({
        name: item.attributes.name,
        id: item.id,
      })),
  },
};
